import { DrawerPanel } from '@dmc/ui';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import EditLoggedInvestigationForm from './components/form/EditLoggedInvestigationForm';
import { useLoadInvestigation } from '../useLoadInvestigation';
import { ModelName } from '@customer/store/types';

export const EditLoggedInvestigationPanel = (): ReactElement => {
  const { t } = useTranslation();

  const { investigation, isLoaded, renderKey } = useLoadInvestigation();

  return (
    <DrawerPanel
      isLoaded={isLoaded}
      header={t('Model.Edit.Title', { modelName: ModelName.Investigation })}
    >
      {investigation && <EditLoggedInvestigationForm key={renderKey} model={investigation} />}
    </DrawerPanel>
  );
};

export default EditLoggedInvestigationPanel;
